import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=e7fdab26&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=js&"
export * from "./NewMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=e7fdab26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fdab26",
  null
  
)

export default component.exports